import { Component, Input, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';

@Component( {
    selector: 'res-publication-edit-abstract',
    templateUrl: './publication-edit-abstract.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationEditAbstractComponent)],
} )
export class PublicationEditAbstractComponent {
    @Input() publication: Publication;
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

}
